export const calculateAngleAroundZeroZero = (x, y) => {
    let angle = 0;

    const theta = Math.atan(Math.abs(x) / Math.abs(y));

    if (y === 0 && x === 0) {
        // theta calculated as NaN because both numbers were 0.
        angle = 0;
    } else if (y >= 0 && x <= 0) {
        // 'bottom left'
        angle = Math.PI + theta;
    } else if (y >= 0 && x >= 0) {
        // 'bottom right'
        angle = Math.PI - theta;
    } else if (y <= 0 && x <= 0) {
        // 'top left'
        angle = 2 * Math.PI - theta;
    } else {
        // 'top right'
        angle = theta;
    }

    return angle;
};
